var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print"},[_c('div',{staticClass:"print-btn"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goPrint}},[_vm._v("Print")])],1),_c('div',{staticClass:"print-box"},[_c('review-confirm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }